import { render } from "./MainTemplate.vue?vue&type=template&id=79b239fc&scoped=true&ts=true"
import script from "./MainTemplate.vue?vue&type=script&lang=ts"
export * from "./MainTemplate.vue?vue&type=script&lang=ts"

import "./MainTemplate.vue?vue&type=style&index=0&id=79b239fc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b239fc"]])

export default __exports__